export const getBUSDAddress = () => {
    // main-net
    return "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
    // test-net
    // return "0xe10fecd363459964cecff2e91feb3cdee3aa7e21";
};

export const getMMProAddress = () => {
    // main-net
    return "0x6067490d05F3cF2fdFFC0e353b1f5Fd6E5CCDF70";
    // test-net
    // return "0xa8892b044ece158cb4869b59f1972fa01aae6d2e"
};

export const getAllocationMarketplaceAddress = () => {
    return "0x591Af485CD0b2500e54D7D32A86112eB07FE088a";
};

export const getPancakeRouterAddress = () => {
    return "0x10ed43c718714eb63d5aa57b78b54704e256024e";
};